import type { StateContext } from '@ngxs/store';
import { produce } from 'immer';
import { findbyId } from '../../../../state_utils';
import { GenerateEChartConfig } from '../actions/other.actions';
import type { OverrideEchartsOptionOnControl, ToggleConfidence, ToggleSensorVisibility } from '../actions/sensortable.actions';
import type { MultiViewStateModel } from '../MultiViewStateModel';
import { getViewIndex } from '.';

export namespace VisualizationHandlers {
  /**
   * Toggles the confidence band of a sensor
   * @param ctx state context
   * @param param1 action parameters
   */
  export function toggleConfidence(ctx: StateContext<MultiViewStateModel>, { control, value }: ToggleConfidence) {
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        const c = draft.views[getViewIndex(ctx)].sensorTable.find(findbyId(control));
        if (!c) {
          return;
        }
        c.confidenceBand = value ?? !c?.confidenceBand;

        draft.views[getViewIndex(ctx)].lanes.forEach((l) => {
          const c = l.controls.find(findbyId(control));
          if (!c) {
            return;
          }
          c.confidenceBand = value ?? !c?.confidenceBand;
        });
        ctx.dispatch(GenerateEChartConfig);
      })
    );
  }

  /**
   * Toggle visibility of a control
   * @param ctx state context
   * @param param1 action parameters
   */
  export function toggleVisibility(ctx: StateContext<MultiViewStateModel>, { control }: ToggleSensorVisibility) {
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        const channel = draft.views[getViewIndex(ctx)].sensorTable.find(findbyId(control));
        if (!channel) {
          return;
        }
        channel.isHidden = !channel?.isHidden;
        draft.views[getViewIndex(ctx)].lanes.forEach((l) => {
          const c = l.controls.find(findbyId(control));
          if (!c) {
            return;
          }
          c.isHidden = !c?.isHidden;
        });
      })
    );
    ctx.dispatch(GenerateEChartConfig);
  }

  /**
   * Override ECharts options on a control
   * @param ctx state context
   * @param param1 action parameters
   */
  export function overrideEchartsOptionOnControl(ctx: StateContext<MultiViewStateModel>, { controlId, opts }: OverrideEchartsOptionOnControl) {
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        const c = draft.views[getViewIndex(ctx)].sensorTable.find(findbyId({ id: controlId }));

        if (!c) {
          return;
        }
        c.seriesOverride = {
          ...c.seriesOverride,
          // biome-ignore lint/suspicious/noExplicitAny: <explanation>
          ...(opts as any),
        };
      })
    );
  }
}
